module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL3.66dbf161.mp3";